$ = require 'jquery'
Keyboard = require 'lib/keyboard'
Keys = require 'data/keys'
PopOver = require 'views/lib/pop-over'
Util = require 'lib/util'
View = require 'view'
_ = require 'underscore'
templates = require 'views/internal/templates'
l = require 'lib/localize'
{ maybeDisplayCardLimitsError } = require 'views/card/card-limits-error'

module.exports = class CalendarCardComposerView extends View
  className: 'calendar-card-composer'

  initialize: ->
    @board = @model.getBoard()

  events:
    'change .js-select-list': 'updatePositionList'
    'change .js-select-position': 'renderValues'
    'click .js-add-card': 'addCard'

    'keydown': 'keydownEvent'

  viewTitleKey: 'add card'

  setDate: (@date) ->
    @date.setHours(12) # Due date defaults to noon, not midnight

  remove: ->
    data =
      title: @$('.js-card-title').val()
      idList: @$('.js-select-list').val()
      pos: @$('.js-select-position').val()

    @model
      .set(data)
      .save()
    super

  render: ->
    data =
      title: @model.get('title')

    @$el.html(templates.fill('popover_card_from_calendar', data))
    @updateListList()
    @updatePositionList()

    @defer =>
      Util.setCaretAtEnd(@$('.js-card-title')[0])

    @

  keydownEvent: (e) ->
    if Keyboard.getKey(e) == Keys.Enter
      @addCard(e)
      return

  addCard: (e) ->
    Util.stop(e)

    cardTitle = $.trim @$('.js-card-title').val()
    return if !cardTitle

    if maybeDisplayCardLimitsError(e, @model.getBoard(), @model.getList())
      return

    PopOver.hide()
    @model.clearItems()
    @model.set('pos', 'bottom')

    list = @selectedList()
    posIndex = parseInt @$('.js-select-position').val()

    cardData =
      closed: false
      dateLastActivity: new Date()
      due: @date.toString()
      idList: list.id
      pos: list.calcPos(posIndex)
      name: cardTitle

    list.cardList.create(cardData)

  updateListList: ->
    $selectList = @$('.js-select-list')

    $selectList.empty()

    lists = @board.listList.models
    _.each lists, (list) ->
      $('<option>').val(list.id).text(list.get('name')).appendTo($selectList)

    $selectList.val(@model.get('idList'))
    if !$selectList.val()
      $selectList.find('option').first().prop('selected', true)

    @renderValues()

  updatePositionList: ->
    $posList = @$('.js-select-position')
    list = @selectedList()

    $posList.empty()

    if list?
      numCards = list.cardList.length
      indexes = [0..numCards]
      _.each indexes, (index) ->
        tag = switch index
          when 0 then ' (Top)'
          when indexes.length - 1 then ' (Bottom)'
          else ''

        $('<option>').val(index).text((index + 1) + tag).appendTo($posList)

      $posList.val(@model.get('pos'))
      if !$posList.val()
        $posList.find('option').last().prop('selected', true)

    @renderValues()

  selectedList: ->
    idList = @$('.js-select-list').val()
    _.findWhere @board.listList.models, { id: idList }

  renderValues: ->
    list = @selectedList()
    $listValue = @$('.js-list-value')
    $posValue = @$('.js-pos-value')

    # It's possible for a board to have no lists
    if list?
      $listValue.text(list.get('name'))
      pos = parseInt @$('.js-select-position').val()
      $posValue.text(pos + 1)
    else
      $listValue.empty().append $('<i></i>').text(l('no lists'))
      $posValue.empty().append $('<i></i>').text(l('n/a'))

    @$('.js-add-card,.js-card-title').prop('disabled', !list?)

    return



// WEBPACK FOOTER //
// ./app/scripts/views/card-composer/calendar-card-composer-view.coffee